import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/assets/action_plus.svg'


const _hoisted_1 = { class: "home w-full" }
const _hoisted_2 = { class: "overflow-x" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "flex-grow bg-background shadow-inner min-h-screen"
}
const _hoisted_5 = { class: "container p-8 flex flex-col lg:flex-row lg:space-x-8 w-full" }
const _hoisted_6 = { class: "card-main w-full lg:w-3/12 rounded-2xl overflow-y-auto h-full" }
const _hoisted_7 = { class: "flex flex-col w-full py-2 rounded-lg space-y-4" }
const _hoisted_8 = { class: "flex justify-end w-full space-x-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY LOCATION ", -1)
const _hoisted_10 = { class: "space-y-3" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", { class: "text-gray-500 select-none" }, " FILTER BY STATUS ", -1)
const _hoisted_12 = { class: "space-y-3" }
const _hoisted_13 = { class: "bg-background" }
const _hoisted_14 = { class: "sm:flex flex-col" }
const _hoisted_15 = { class: "sm:flex md:flex-col lg:flex-row justify-between items-center" }
const _hoisted_16 = { class: "sm:flex md:flex-col flex-row items-center w-full lg:w-2/5" }
const _hoisted_17 = { class: "sm:space-y-0 sm:flex flex-row items-center justify-between py-5 lg:w-3/5 w-full relative" }
const _hoisted_18 = { class: "flex flex-col lg:flex-row justify-between items-center space-x-1 lg:space-y-0 md:space-y-0 md:flex-row md:mt-4 lg:mt-0 space-y-4 w-full" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { key: 1 }
const _hoisted_22 = {
  key: 2,
  class: "w-full flex flex-row justify-center"
}
const _hoisted_23 = { class: "flex justify-end w-full" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("svg", {
  class: "h-8 w-8 text-gray-400",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  "stroke-width": "2",
  stroke: "currentColor",
  fill: "none",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    stroke: "none",
    d: "M0 0h24v24H0z"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "18",
    y1: "6",
    x2: "6",
    y2: "18"
  }),
  /*#__PURE__*/_createElementVNode("line", {
    x1: "6",
    y1: "6",
    x2: "18",
    y2: "18"
  })
], -1)
const _hoisted_25 = [
  _hoisted_24
]
const _hoisted_26 = /*#__PURE__*/_createTextVNode(" You are accepting ")
const _hoisted_27 = { class: "flex justify-end w-full" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_Loading = _resolveComponent("Loading")!
  const _component_RadioButton = _resolveComponent("RadioButton")!
  const _component_CheckBoxGroup = _resolveComponent("CheckBoxGroup")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_Button = _resolveComponent("Button")!
  const _component_JobsEmptyState = _resolveComponent("JobsEmptyState")!
  const _component_JobCard = _resolveComponent("JobCard")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_AddTemplateToJob = _resolveComponent("AddTemplateToJob")!
  const _component_ReusableModal = _resolveComponent("ReusableModal")!
  const _component_AddRecruiterToJob = _resolveComponent("AddRecruiterToJob")!
  const _component_AddChallengeToJob = _resolveComponent("AddChallengeToJob")!
  const _component_CloseJob = _resolveComponent("CloseJob")!
  const _component_ModalUpgradePlan = _resolveComponent("ModalUpgradePlan")!
  const _component_base_modal = _resolveComponent("base-modal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_Header)
      ]),
      (_ctx.isLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(_component_Loading, {
              active: _ctx.isLoading,
              "onUpdate:active": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.isLoading) = $event)),
              "can-cancel": false,
              loader: "spinner",
              color: "#8908F9",
              width: 128,
              height: 128,
              "is-full-page": true
            }, null, 8, ["active"])
          ]))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, [
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary-dark text-md font-bold",
                      onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.clearResults && _ctx.clearResults(...args)))
                    }, " Clear all "),
                    _createElementVNode("button", {
                      type: "button",
                      class: "text-primary text-md font-bold",
                      onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getAllResults && _ctx.getAllResults(...args)))
                    }, " Apply ")
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.expand.location = !_ctx.expand.location)),
                    class: "flex flex-row justify-between items-center w-full"
                  }, [
                    _hoisted_9,
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down text-gray-500", _ctx.expand.location && 'transform rotate-180 '])
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_10, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locations, (item, index) => {
                      return (_openBlock(), _createBlock(_component_RadioButton, {
                        key: `radio-${item}-${index}`,
                        label: item,
                        value: item,
                        modelValue: _ctx.radioLocation,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.radioLocation) = $event))
                      }, null, 8, ["label", "value", "modelValue"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.location]
                  ]),
                  _createElementVNode("div", {
                    onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.expand.status = !_ctx.expand.status)),
                    class: "flex flex-row justify-between w-full"
                  }, [
                    _hoisted_11,
                    _createElementVNode("i", {
                      class: _normalizeClass(["fas fa-chevron-down text-gray-500", _ctx.expand.status && 'transform rotate-180 '])
                    }, null, 2)
                  ]),
                  _withDirectives(_createElementVNode("div", _hoisted_12, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jobStatus, (item, index) => {
                      return (_openBlock(), _createBlock(_component_CheckBoxGroup, {
                        key: `item-checkbox-${index + 1}`,
                        fieldId: item.id,
                        names: _ctx.checkValues,
                        "onUpdate:names": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.checkValues) = $event)),
                        label: item.name,
                        value: item.id
                      }, null, 8, ["fieldId", "names", "label", "value"]))
                    }), 128))
                  ], 512), [
                    [_vShow, _ctx.expand.status]
                  ])
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(["flex-grow bg-background shadow-inner min-h-screen max-h-full lg:w-9/12 w-full mt-4 lg:mt-0", _ctx.jobsStore && _ctx.jobsStore.length > 0 && 'h-full'])
              }, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_SearchInput, {
                          placeholder: "Start typing to search jobs...",
                          modelValue: _ctx.inputValue,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputValue) = $event)),
                          onOnSubmit: _ctx.searchFilter,
                          onClearResults: _ctx.clearResults,
                          clearButton: true
                        }, null, 8, ["modelValue", "onOnSubmit", "onClearResults"])
                      ]),
                      _createElementVNode("div", _hoisted_17, [
                        _createElementVNode("div", _hoisted_18, [
                          _createVNode(_component_CustomDropdown, {
                            filters: _ctx.deparments,
                            modelValue: _ctx.select,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.select) = $event)),
                            label: _ctx.label
                          }, null, 8, ["filters", "modelValue", "label"]),
                          _createVNode(_component_Button, {
                            variant: "",
                            label: _ctx.exclude ? 'Include drafts' : 'Exclude drafts',
                            onOnClick: _cache[9] || (_cache[9] = ($event: any) => {
                        _ctx.setExclude(!_ctx.exclude);
                        _ctx.searchFilter();
                      })
                          }, null, 8, ["label"]),
                          _createVNode(_component_Button, {
                            variant: "contained",
                            label: "Create new job",
                            onOnClick: _ctx.createJob
                          }, {
                            startIcon: _withCtx(() => [
                              _hoisted_19
                            ]),
                            _: 1
                          }, 8, ["onOnClick"])
                        ])
                      ])
                    ]),
                    (_ctx.jobsStore && _ctx.jobsStore.jobs && _ctx.jobsStore.jobs.length <= 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _createVNode(_component_JobsEmptyState)
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.jobsStore && _ctx.jobsStore.jobs && _ctx.jobsStore.jobs.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                          _createVNode(_component_JobCard, {
                            jobs: _ctx.jobsStore.jobs,
                            onOpenTemplate: _ctx.openTemplate,
                            onOpenChallenge: _ctx.openChallenge,
                            onAssignJob: _ctx.assignJob,
                            onDeactivateJob: _ctx.deactivateJob,
                            onAcceptManageJob: _ctx.acceptManageJob
                          }, null, 8, ["jobs", "onOpenTemplate", "onOpenChallenge", "onAssignJob", "onDeactivateJob", "onAcceptManageJob"])
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.jobsStore && _ctx.jobsStore.jobs && _ctx.jobsStore.jobs.length > 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                          _createVNode(_component_Paginator, {
                            modelValue: Number(_ctx.page),
                            page: _ctx.page,
                            pages: _ctx.jobsStore?.meta?.pagination?.total_pages,
                            "range-size": 1,
                            "onUpdate:modelValue": _ctx.updateHandler,
                            total: _ctx.jobsStore?.meta?.pagination?.total_count,
                            from: _ctx.jobsStore?.meta?.pagination?.from,
                            to: _ctx.jobsStore?.meta?.pagination?.to
                          }, null, 8, ["modelValue", "page", "pages", "onUpdate:modelValue", "total", "from", "to"])
                        ]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ], 2)
            ])
          ]))
    ]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModal,
      onClose: _cache[12] || (_cache[12] = ($event: any) => (_ctx.setShowModal(false))),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddTemplateToJob, {
          id: _ctx.selectedId,
          onReload: _cache[10] || (_cache[10] = () => _ctx.getAllResults(_ctx.page)),
          onClose: _cache[11] || (_cache[11] = ($event: any) => (_ctx.setShowModal(false)))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showRecruiter,
      onClose: _cache[15] || (_cache[15] = ($event: any) => (_ctx.setShowRecruiter(false))),
      size: "w-3/6"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddRecruiterToJob, {
          job: _ctx.dataJob,
          onReload: _cache[13] || (_cache[13] = () => _ctx.getAllResults(1)),
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.setShowRecruiter(false)))
        }, null, 8, ["job"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showChallenge,
      onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setShowChallenge(false))),
      size: "w-1/3"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_AddChallengeToJob, {
          id: _ctx.selectedId,
          onReload: _cache[16] || (_cache[16] = () => _ctx.getAllResults(_ctx.page)),
          onClose: _cache[17] || (_cache[17] = ($event: any) => (_ctx.setShowChallenge(false)))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showCloseJob,
      onClose: _cache[21] || (_cache[21] = ($event: any) => (_ctx.setShowCloseJob(false))),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_CloseJob, {
          id: _ctx.selectedId,
          onReload: _cache[19] || (_cache[19] = () => _ctx.getAllResults(1)),
          onClose: _cache[20] || (_cache[20] = ($event: any) => (_ctx.setShowCloseJob(false)))
        }, null, 8, ["id"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_ReusableModal, {
      show: _ctx.showModalUpgrade,
      onClose: _cache[23] || (_cache[23] = ($event: any) => (_ctx.showModalUpgrade = false)),
      size: "lg:w-1/3 md:w-9/12 w-11/12"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_ModalUpgradePlan, {
          onCloseModal: _cache[22] || (_cache[22] = ($event: any) => (_ctx.showModalUpgrade = false)),
          infoType: "jobs"
        })
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_component_base_modal, { visible: _ctx.showConfirmationModal }, {
      close: _withCtx(() => [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("button", {
            onClick: _cache[24] || (_cache[24] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(false)), ["prevent"])),
            class: "p-1 rounded-lg cursor-pointer"
          }, _hoisted_25)
        ])
      ]),
      "alert-text": _withCtx(() => [
        _createElementVNode("div", null, [
          _hoisted_26,
          _createElementVNode("strong", null, _toDisplayString(_ctx.jobName), 1),
          _createTextVNode(" as a as a managed job. When added to your account " + _toDisplayString(_ctx.profile.company.company_country.short_code === "MX"
            ? "10,000 MXN + IVA"
            : "499 USD") + " will be added to bill next cycle. ", 1)
        ])
      ]),
      actions: _withCtx(() => [
        _createElementVNode("div", _hoisted_27, [
          _createElementVNode("button", {
            class: "btn-filled-sm flex flex-row items-center disabled:opacity-50 justify-between truncate sm:text-base bg-primary rounded-full transition duration-150 ease-in",
            onClick: _cache[25] || (_cache[25] = _withModifiers(($event: any) => (_ctx.confirmationModal.tell(true)), ["prevent"]))
          }, " Confirm ")
        ])
      ]),
      _: 1
    }, 8, ["visible"])
  ], 64))
}